@if (groupedProducts.length > 0) {
  <mat-tab-group disableRipple="true" mbnmAddClass="product-selector" mbnmAddClassSelector="mat-tab-header, .mat-tab-body-wrapper"
    [selectedIndex]="selectedTabIndex"
    (click)="$event.stopPropagation();" [ngClass]="{'hide-tabs': groupedProducts && groupedProducts.length == 1}"
    (selectedTabChange)="tabChanged($event)">
    @for (productGroup of groupedProducts; track productGroup; let i = $index) {
      <mat-tab>
        <ng-template mat-tab-label>
          <div>
            @if (productGroup.thumb) {
              <img [alt]="'Product Group - ' + productGroup.title" [src]="productGroup.thumb" />
            }
            <div [ngClass]="{'no-thumb': !productGroup.thumb}" [innerHTML]="productGroup.title">
            </div>
            @if (productGroup.hasSaleItems) {
              <div class="sale-badge">
                SALE
              </div>
            }
          </div>
        </ng-template>
        @if (productGroup.products.length == 0) {
          <div class="placeholder"></div>
        }
        @if (productGroup.products.length >= 1) {
          <div>
            @if (i == 0 || productGroup.loadContent) {
              <mat-grid-list [cols]="media.isMatched(BREAKPOINTS.Standard.XSmall) ? mobileCols : cols"
                [rowHeight]="(media.isMatched(BREAKPOINTS.Standard.XSmall) ? mobileCols : cols) == 1 ? 85 : 165"
                gutterSize="5"
                >
                @for (product of productGroup.products; track product) {
                  <mat-grid-tile
                    (click)="choose(product)" [ngClass]="{'disabled': product.disabled, 'selected': isSelected(product)}">
                    <div class="wrapper" [ngClass]="{'no-thumb': !product.thumb, 'single-col': (media.isMatched(BREAKPOINTS.Standard.XSmall) ? mobileCols : cols) == 1}">
                      <div class="thumb-block">
                        @if (product.thumb) {
                          <img [src]="product.thumb" [alt]="partDisplay.description(product)" >
                        }
                        @if (!product.fixedPrice && product.saleUnitPrice && product.saleUnitPrice < product.unitPrice) {
                          <div class="sale">
                            {{ 1 - product.saleUnitPrice / product.unitPrice | percent }} OFF
                          </div>
                        }
                        @if (product.fixedPrice) {
                          <div class="price" [innerHtml]="product.fixedPrice | currency2"></div>
                        }
                      </div>
                      <div class="description-block">
                        <label class="description" [innerHtml]="partDisplay.description(product)"></label>
                        <div class="long-description" [innerHtml]="partDisplay.longDescription(product)"></div>
                      </div>

                    </div>
                  </mat-grid-tile>
                }
              </mat-grid-list>
            }
            @if (i > 0 && !productGroup.loadContent) {
              <mat-spinner color="secondary"></mat-spinner>
            }
          </div>
        }
      </mat-tab>
    }
  </mat-tab-group>
}
@if (groupedProducts.length == 0) {
  <div class="none-available">
    {{ noProductsAvailableMessage }}
  </div>
}
